import React, { Component } from 'react';
import { connect } from "react-redux";
import {getBarWidth} from './getBarWidth.js';
import PatternComponent from './PatternComponent.js';
import {
    PATTERN_SWITCH,
    NO_SUB_SEQUENCE,
    SEQUENCE_ROLL,
    RESOLUTION_CHANGE} from 'session/constants.js';

const RIGHT = 'RIGHT';
const LEFT = 'LEFT';

function RollComponent(props) {
    let event = props.event;

    if (!event.value) {
        // sequence_roll OFF is represented as empty, visually
        let style = {
            width: getBarWidth(props.duration, props.resolution, props.xScale),
            opacity: 0.001,
        };
        
        return (
            <div className="empty-roll-event" style={style}>
              <div style={style}/>
            </div>
        );
    }
    
    let step = event.step;
    let duration = event.duration;
    let width = getBarWidth(duration, props.resolution, props.xScale);
    let style = {
        width: width, 
    };
    
    let subEvents = props.event.getSubEvents();
    return (
        <div style={style} className={"roll-event step-" + props.event.step}>
          {subEvents.map(
              (event, i) =>
                  <PatternComponent
                        subSequence={NO_SUB_SEQUENCE}
                        maxWidth={width}
                        key={event.id}
                        eventKey={'roll-'+Math.pow(event.value + 4, 8)}
                        type={SEQUENCE_ROLL}
                        isRoll={true}
                        resolution={props.resolution}
                        isLast={i === subEvents.length - 1}
                        isFirst={i === 0}
                        onDragStart={(e) => []}
                        onSelect={(e) => {
                            props.onSelect(props.event, event, e);
                        }}
                        onMouseUp={(e) => props.onMouseUp(event)}
                        onRightMouseUp={(e) => props.onRightMouseUp(props.event, event)}
                        onRightMouseDown={(e) => props.onRightMouseDown(props.event, event)}
                        onLeftMouseUp={(e) => props.onLeftMouseUp(props.event, event)}
                        onLeftMouseDown={(e) => props.onLeftMouseDown(props.event, event)}
                        mixSession={props.mixSession}
                        sequencerEngine={props.sequencerEngine}
                        event={event}/>
          )}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        duration: props.event.duration,
        subEventsLength: props.event.subEvents.length,
        xScale: state.arrangement.xScale
    };
}
 
export default connect(mapStateToProps, null)(RollComponent);
